<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-alert v-if="$route.params.message" :show="5" dismissible>
            {{ $route.params.message }}
        </b-alert>


        <div v-if="!this.space" class="d-flex justify-content-center mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>

        <div v-else>
            <div>
                <b-row>
                    <b-col md="12">
                        <h3>Space - {{ space.name }} (<a :href="this.$portalURL + '/spaces/' + this.$route.params.uuid"
                                target="_blank">Go to portal</a>)
                        </h3>
                    </b-col>
                </b-row>
            </div>

            <b-tabs content-class="mt-3" justified>
                <b-tab title="Details" active>
                    <b-form v-if="this.prototype" class="px-2" @submit="onSubmit">

                        <b-form-group label-cols-lg="2" label="Title" label-for="input-title">
                            <b-form-input id="input-title" v-model="space.name" required></b-form-input>
                        </b-form-group>

                        <b-form-group label-cols-lg="2" label="Readable ID" label-for="input-readable-id">
                            <b-form-invalid-feedback v-if="this.invalidFeedback" :force-show="true">{{
                                this.invalidFeedback.readable_id[0]
                            }}</b-form-invalid-feedback>
                            <b-form-input id="input-readable-id" v-model="space.readable_id" required
                                v-slugify></b-form-input>
                        </b-form-group>

                        <b-form-group label-cols-lg="2" label="Description" label-for="input-description">
                            <b-form-textarea id="input-description" v-model="space.description" />
                        </b-form-group>

                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Category
                            </b-col>
                            <b-col md="4">
                                <b-form-select placeholder="" id="input-visible" v-model="space.category[0]"
                                    :options="options" />
                            </b-col>

                            <b-col md="2">
                                Min. req. client version
                            </b-col>

                            <b-col md="4">
                                <b-form-input id="input-min-req-version" v-model="space.min_req_client_version" />
                            </b-col>

                        </b-row>

                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Min. req. performance level
                            </b-col>
                            <b-col md="4">
                                <b-form-select placeholder="" id="input-visible" v-model="space.min_req_perf_level"
                                    :options="perf_options" />
                            </b-col>

                        </b-row>

                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Public
                            </b-col>
                            <b-col md="4">
                                <b-form-checkbox id="input-public" v-model="space.is_public" />
                            </b-col>

                            <b-col md="2">
                                Monitoring enabled
                            </b-col>

                            <b-col md="4">
                                <b-form-checkbox id="input-monitoring-enabled" v-model="space.monitoring_enabled" />
                            </b-col>

                        </b-row>

                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Available on web
                            </b-col>
                            <b-col md="4">
                                <b-form-checkbox id="input-is-available-web" v-model="space.is_available_web" />
                            </b-col>

                            <b-col md="2">
                                Is demo
                            </b-col>

                            <b-col md="4">
                                <b-form-checkbox id="input-is-sandbox" v-model="space.is_sandbox" />
                            </b-col>

                        </b-row>


                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Tags
                            </b-col>
                            <b-col md="4">
                                <div v-if="this.space.tag">{{ space.tag.join(", ") }}</div>
                            </b-col>

                            <b-col md="2">
                                Prototype uuid
                            </b-col>

                            <b-col md="4">
                                <router-link :to="'/prototype/' + this.prototype.prototype_uuid">
                                    {{ this.prototype.prototype_uuid }}</router-link>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Status
                            </b-col>
                            <b-col md="4">
                                <b-form-select placeholder="" id="input-visible" v-model="space.status"
                                    :options="space_status" />
                            </b-col>

                            <b-col md="2">
                                Tar (size: {{ (this.prototype.resource_tar_length / 1024 ** 2).toFixed(2) }}MB)
                            </b-col>
                            <b-col md="4">
                                <a :href="this.prototype.resource_tar">Download tar file</a>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Updated at
                            </b-col>
                            <b-col md="4">
                                {{ new Date(this.space.updated_at).toLocaleString() }}
                            </b-col>
                            <b-col md="2">
                                ZIP (size: {{ (this.prototype.resource_zip_length / 1024 ** 2).toFixed(2) }}MB)
                            </b-col>
                            <b-col md="4">
                                <a :href="this.prototype.resource_zip">Download zip file</a>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3" align-v="center">
                            <b-col md="2">
                                Space creator
                            </b-col>
                            <b-col md="4">
                                {{ this.space.created_by }}
                            </b-col>
                            <b-col md="2">
                                Space owner
                            </b-col>
                            <b-col md="4">
                                <ejs-dropdownlist id='dropdownlist' placeholder='Owner email' :allowFiltering='true'
                                    :dataSource='list_of_users' :fields='user_select_fields' v-model='space.owned_by'>
                                </ejs-dropdownlist>
                            </b-col>
                        </b-row>


                        <b-button :disabled="upload_data" type="submit" variant="primary">Update space details <b-spinner
                                v-if="upload_data" small label="Loading..." /></b-button>

                        <b-button :disabled="upload_data" variant="danger" class="float-right" @click="deleteSpace">Delete
                            space</b-button>
                    </b-form>
                </b-tab>
                <b-tab title="Users">
                    <b-container>
                        <b-row>
                            <b-col>
                                <b-button :disabled="!userEmail || !user_permission" variant="success"
                                    @click="submitNewUser()" class="mb-3">
                                    Add user
                                </b-button>
                            </b-col>
                            <b-col cols="8">
                                <ejs-dropdownlist id='dropdownlist' placeholder='User email' :allowFiltering='true'
                                    :dataSource='list_of_users' :fields='user_select_fields' v-model='userEmail'>
                                </ejs-dropdownlist>
                            </b-col>
                            <b-col>
                                <ejs-dropdownlist id='dropdownlist' placeholder='Permission'
                                    :dataSource='list_of_permission' :fields='permission_fields'
                                    v-model='user_permission'></ejs-dropdownlist>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table id="my-table-users" :fields="user_fields" :items="space.shared_with" :per-page="perPage"
                        :current-page="currentPageUser" :sort-by.sync="email" small striped>
                        <template v-slot:cell(email)="data">
                            <router-link :to="'/user/' + data.item.uuid">{{ data.value }}</router-link>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                                @click="remove_user_from_space(data.item)" />
                        </template>
                    </b-table>
                    <b-pagination v-model="currentPageUser" :total-rows="space.shared_with.length" :per-page="perPage"
                        align="fill" size="sm" class="my-0" />

                    <div v-if="this.superadmin" class="my-3">
                        <h4>Superadmins</h4>
                        <b-table id="my-table-superadmins" v-if="this.superadmin" :items="superadmin"
                            :fields="superadmin_fields" :per-page="perPage" :current-page="currentPageSuperadmin"
                            :sort-by.sync="name" small striped>
                            <template v-slot:cell(email)="data">
                                <router-link :to="'/user/' + data.item.uuid">{{ data.value }}</router-link>
                            </template>
                        </b-table>
                        <b-pagination v-model="currentPageSuperadmin" :total-rows="space.projects.length"
                            :per-page="perPage" align="fill" size="sm" class="my-0" />
                    </div>
                </b-tab>
                <b-tab title="Projects">
                    <b-table id="my-table-users" :fields="project_fields" :items="space.projects" :per-page="perPage"
                        :current-page="currentPageProject" :sort-by.sync="name" small striped>
                        <template v-slot:cell(name)="data">
                            <router-link :to="'/project/' + data.item.uuid">{{ data.value }}</router-link>
                        </template>
                        <template v-slot:cell(is_public)="data">
                            <label v-if="data.value">&#9989;</label>
                            <label v-else>&#10060;</label>
                        </template>
                        <template v-slot:cell(auto_load)="data">
                            <label v-if="data.value">&#9989;</label>
                            <label v-else>&#10060;</label>
                        </template>
                        <template v-slot:cell(is_sandbox)="data">
                            <label v-if="data.value">&#9989;</label>
                            <label v-else>&#10060;</label>
                        </template>
                        <template v-slot:cell(unlisted)="data">
                            <label v-if="data.value">&#9989;</label>
                            <label v-else>&#10060;</label>
                        </template>
                    </b-table>
                    <b-pagination v-model="currentPageProject" :total-rows="space.projects.length" :per-page="perPage"
                        align="fill" size="sm" class="my-0" />
                </b-tab>
                <b-tab title="Logs" :disabled="list_of_logs.length == 0">
                    <b-row class="my-2">
                        <b-col md="10">
                            <ejs-dropdownlist id='dropdownlist' placeholder='Filter by user email' :allowFiltering='true'
                                :dataSource='listOfLogUsers' v-model='logUserEmail'>
                            </ejs-dropdownlist>
                        </b-col>
                        <b-col md="2">
                            <b-button @click="clear_filter()">Clear filter</b-button>
                        </b-col>

                    </b-row>

                    <b-table id="my-table-users" :fields="log_fields" :items="list_of_logs" :sort-by.sync="created_at"
                        :sort-desc.sync="sortOrder" :filter="logUserEmail" :filter-included-fields="filterOn" small striped>
                        <template v-slot:cell(file_name)="data">
                            <b-link @click="download_log(data.value)">{{ data.value }}</b-link>
                        </template>
                        <template v-slot:cell(created_at)="data">
                            <span>{{ new Date(data.value).toLocaleString() }}</span>
                        </template>
                        <template v-slot:cell(graph)="data">
                            <b-button variant="success" @click="show_graph_modal(data)">Show</b-button>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>

            <b-modal id="modalPopover" title="User journey graph" size="xl" @shown="show_plotly" ok-only>
                <div ref="plotlyGraph"></div>
            </b-modal>
        </div>


    </b-container>
</template>


<script>
import Alert from '../components/alert.vue';
import { BIconTrashFill } from 'bootstrap-vue';
import Plotly from 'plotly.js';

export default {
    data() {
        return {
            invalidFeedback: null,
            email: 'email',
            name: 'name',
            created_at: 'created_at',
            sortOrder: true,
            message: '',
            space: null,
            prototype: null,
            superadmin: null,
            userEmail: null,
            logUserEmail: null,
            perPage: 20,
            currentPageUser: 1,
            currentPageProject: 1,
            currentPageSuperadmin: 1,
            filterOn: ['user_email'],
            user_fields: [
                { key: 'email', label: 'Email', class: 'text-center align-middle', sortable: true },
                { key: 'permission', label: 'Permission', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            user_select_fields: { text: "email", value: "email" },
            project_fields: [
                { key: 'name', label: 'Name', class: 'text-center align-middle', sortable: true },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'number_of_smartboards', label: 'Number of smartboards', class: 'text-center align-middle' },
                { key: 'is_public', label: 'Is public', class: 'text-center align-middle' },
                { key: 'auto_load', label: 'Auto load', class: 'text-center align-middle' },
                { key: 'is_sandbox', label: 'Is sandbox', class: 'text-center align-middle' },
                { key: 'unlisted', label: 'Is unlisted', class: 'text-center align-middle' }
            ],
            log_fields: [
                { key: 'file_name', label: 'Name', class: 'text-center align-middle', sortable: true },
                { key: 'user_email', label: 'User', class: 'text-center align-middle', sortable: true },
                { key: 'created_at', label: 'Created at', class: 'text-center align-middle', sortable: true },
                { key: 'graph', label: 'Graphicon', class: 'text-center align-middle' }
            ],
            superadmin_fields: [
                { key: 'email', label: 'Email', class: 'text-center align-middle' },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
            ],
            list_of_users: [],
            options: [
                { value: "event", text: "event" },
                { value: "education", text: "education" },
                { value: "enterprise", text: "enterprise" },
                { value: "exhibition", text: "exhibition" },
            ],
            space_status: [
                { value: "active", text: "active" },
                { value: "disabled", text: "disabled" },
                { value: "suspended", text: "suspended", disabled: true },
                { value: "locked", text: "locked", disabled: true },
                { value: "unavailable", text: "unavailable", disabled: true },
                { value: "scheduled to remove", text: "scheduled to remove", disabled: true }
            ],
            list_of_permission: [
                { text: 'Viewer', value: 1 },
                { text: 'Editor', value: 2 },
                { text: 'Admin', value: 3 },
                { text: 'Owner', value: 4 }
            ],
            perf_options: [
                { value: null, text: "-"},
                { value: 0, text: "0 - Punch card computer" },
                { value: 1, text: "1 - Commodore 64" },
                { value: 2, text: "2 - Integrated laptop GPU" },
                { value: 3, text: "3 - Desk Computer" },
                { value: 4, text: "4 - PC Master Race" },
            ],
            permission_fields: { text: "text", value: "value" },
            list_of_logs: null,
            user_permission: null,
            upload_data: false,
            listOfLogUsers: []
        }
    },
    components: {
        BIconTrashFill,
        alert: Alert,
    },
    methods: {
        init() {
            this.invalidFeedback = null;
            this.download_space_details();
            this.download_prototype();
            this.download_users();
            this.download_superadmins();
            this.download_logs();
        },
        clear_filter() {
            this.logUserEmail = null
        },
        download_log(log_id) {
            console.log(log_id)
            this.$http.get(this.$apiURL + '/static_analytic/' + log_id, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.$http.get(res.data.url, { responseType: 'blob' })
                        .then(response => {
                            const blob = new Blob([response.data], { type: 'application/txt' })
                            const link = document.createElement('a')
                            link.href = URL.createObjectURL(blob)
                            link.download = log_id
                            link.click()
                            URL.revokeObjectURL(link.href)
                        }).catch(console.error)
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_logs() {
            this.$http.post(this.$apiURL + '/static_analytic', { space_uuid: this.$route.params.uuid }, { headers: this.$store.getters.authHeader })
                .then((resp) => {
                    this.list_of_logs = resp.data
                    for (var i in this.list_of_logs) {
                        if (this.listOfLogUsers.indexOf(this.list_of_logs[i].user_email) == -1) {
                            this.listOfLogUsers.push(this.list_of_logs[i].user_email)
                        }
                    }
                    this.listOfLogUsers.sort((a, b) => a - b)
                })
                .catch((error) => {
                    console.log(error)
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_users() {
            this.$http.post(this.$apiURL + '/admin/users',
                {}, {
                headers: this.$store.getters.authHeader
            })
                .then((resp) => {
                    this.list_of_users = resp.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_superadmins() {
            this.$http.post(this.$apiURL + '/admin/users',
                { role_id: 1 }, {
                headers: this.$store.getters.authHeader
            })
                .then((resp) => {
                    this.superadmin = resp.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_space_details() {
            this.$http.get(this.$apiURL + '/space/' + this.$route.params.uuid + "/details", { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.space = res.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        download_prototype() {
            this.$http.get(this.$apiURL + '/space/' + this.$route.params.uuid + "/download", { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.prototype = res.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        submitNewUser() {
            this.$http.post(this.$apiURL + '/space/' + this.$route.params.uuid + '/share', [{ email: this.userEmail, permission_id: this.user_permission }], { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.userEmail = null
                    this.user_permission = null
                    this.message = { 'message': "User has been set." }
                    this.init();
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data,
                        'type': "danger"
                    }

                });
        },
        remove_user_from_space(row) {
            this.$dialog
                .confirm("Are you sure about the delete of the user?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/space/' + this.$route.params.uuid + '/share', { headers: this.$store.getters.authHeader, data: [{ email: row.email, permission_id: row.permission_id }] }
                    )
                        .then((res) => {
                            this.message = {
                                'message': "You removed user '" + row.email + "' succesfully!",
                                'type': "danger"
                            }
                            this.download_space_details()
                        })
                        .catch((error) => {
                            this.message = {
                                'message': error.response.data.message,
                                'type': "danger"
                            }
                        });
                });
        },
        show_graph_modal(data) {
            this.$http.get(this.$apiURL + '/static_analytic/' + data.item.file_name + '/plotly', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.graph_data = res.data
                    this.$bvModal.show('modalPopover')
                    
                })
                .catch((error) => {
                    this.message = {
                        'message': 'Graph generation error with not valid file: ' + error.response.data,
                        'type': "danger"
                    }
                });         
        },
        show_plotly() {
            Plotly.react(this.$refs.plotlyGraph, this.graph_data);
        },
        onSubmit(event) {
            this.upload_data = true;
            event.preventDefault()
            this.$http.patch(this.$apiURL + '/admin/space/' + this.$route.params.uuid, {
                category: this.space.category[0],
                is_sandbox: this.space.is_sandbox,
                is_available_web: this.space.is_available_web,
                name: this.space.name,
                description: this.space.description ? this.space.description : "",
                is_public: this.space.is_public,
                status: this.space.status,
                owner: this.space.owned_by,
                monitoring_enabled: this.space.monitoring_enabled,
                min_req_client_version: this.space.min_req_client_version,
                min_req_perf_level: this.space.min_req_perf_level,
                readable_id: this.space.readable_id
            },
                { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    if (res.status == 207) {
                        this.message = { 'message': "Space has been updated! New space owner's spaces has been set to suspended, because of the violation of the limits!", type: "warning" }
                    }
                    else {
                        this.message = { 'message': "Space has been updated!" }
                    }
                    this.init();
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.invalidFeedback = error.response.data
                    }
                    else {
                        this.message = { 'message': error.response.data, 'type': "danger" }
                    }
                })
                .finally(() => {
                    this.upload_data = false;
                });
        },
        deleteSpace() {
            this.$dialog
                .confirm("Are you sure about the delete the space?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/space/' + this.$route.params.uuid, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.$router.push({ name: "prototype", params: { uuid: this.prototype.prototype_uuid, message: "Space has been removed!" } })
                        })
                        .catch((error) => {
                            console.log(error)
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        });
                });
        }
    },
    created() {
        this.init();
    },
}
</script>
